import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";

export const PlatformSettingsCard = () => {
  const [f, setF] = useState({ monthly_price: "", whatsapp: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/platform/settings").then((r) => setF({ monthly_price: String(r.data.monthly_price), whatsapp: r.data.whatsapp })).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/platform/settings", { monthly_price: Number(String(f.monthly_price).replace(",", ".")), whatsapp: f.whatsapp });
      toast.success("Configurações salvas. Novas assinaturas usam o novo valor.");
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} className="grid gap-4 rounded-xl border border-slate-700/60 bg-slate-800/60 p-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end" data-testid="platform-settings-card">
      <div className="space-y-1.5">
        <Label htmlFor="ps_price">Valor mensal (R$)</Label>
        <Input id="ps_price" inputMode="decimal" value={f.monthly_price} onChange={(e) => setF({ ...f, monthly_price: e.target.value })} className="bg-slate-950 font-mono" data-testid="platform-price-input" />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="ps_wa">Seu WhatsApp (página de vendas)</Label>
        <Input id="ps_wa" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} className="bg-slate-950 font-mono" data-testid="platform-whatsapp-input" />
      </div>
      <Button type="submit" disabled={saving} className="rounded-full font-semibold" data-testid="platform-settings-save">
        {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar
      </Button>
    </form>
  );
};
